import { useEffect, useState } from "react";
import CreditCardInput from "react-credit-card-input";

const NestPayCard = ({ setCardInfo, goBack }) => {

    const [cardNumber, setCardNumber] = useState("");
    const [cardExpiry, setCardExpiry] = useState("");
    const [cardCvc, setCardCvc] = useState("");

    useEffect(() => {
        let number = cardNumber.replaceAll(" ", "");

        if (number.length < 16) {
          setCardInfo(null);
            return;
        }

        const cardExpiryArray = cardExpiry
            .split("/")
            .map((item) => item.trim());
        if (cardExpiryArray.length < 2) {
          setCardInfo(null);
            return;
        }

        if (cardCvc.length < 3) {
          setCardInfo(null);
            return;
        }

        setCardInfo({
            number: number,
            expM: cardExpiryArray[0],
            expY: cardExpiryArray[1],
            cvc: cardCvc,
        });
    }, [cardNumber, cardExpiry, cardCvc, setCardInfo]);

    return (
        <div className="flex flex-col items-start gap-2 m-auto">
            <CreditCardInput
                cardNumberInputProps={{
                    value: cardNumber,
                    onChange: (e) => setCardNumber(e.target.value),
                }}
                cardExpiryInputProps={{
                    value: cardExpiry,
                    onChange: (e) => setCardExpiry(e.target.value),
                }}
                cardCVCInputProps={{
                    value: cardCvc,
                    onChange: (e) => setCardCvc(e.target.value),
                }}
                fieldClassName="input"
            />
        </div>
    );
};

export default NestPayCard;
